// extracted by mini-css-extract-plugin
module.exports = {"badge":"QaModeBadge_badge__cgD9i","dot":"QaModeBadge_dot__1aaCK","qaPulse":"QaModeBadge_qaPulse__3LGeH"};